import React, {useCallback, useEffect, useState} from "react";
import {Button,  Modal} from "antd";
import "./modalLogin.scss";
import FormLogin from "../formLogin/formLogin";
import {useLockBodyScroll} from "../../hooks/useLockBodyScroll";
import FormRegister from "../formRegister/formRegister";
import {ColorStripe} from "../colorStripe/colorStripe";
import useWindowViewport from "../../hooks/useWindowViewport";
import {MessageSuccess} from "../messageSuccess/messageSuccess";

export const ModalLogin = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isFormLogin, setIsFormLogin] = useState(true);
    const [isFormComplete, setIsFormComplete] = useState(false);
    const [titleMessage, setTitleMessage] = useState("");
    const [isFormRegister, setIsFormRegister] = useState(false);
    const [description, setDescription] = useState("");
    const {windowWidth} = useWindowViewport();
    const [isMobile, setIsMobile] = useState(false);
    const [msg, setMsg] = useState("");
    const [statusForm, setStatusForm] = useState(false);

    const handleCancel = useCallback(() => {
        if (isFormComplete) {
            setIsFormComplete(false);
            setIsFormLogin(true);
            setIsFormRegister(false);
        }
        setMsg("");
        setIsModalOpen(false);
    }, [isFormComplete]);

    useLockBodyScroll(isModalOpen);

    const showModal = () => setIsModalOpen(true);

    const handleFormSubmit = (value,text,description,statusForm, isRegister) => {
        setIsFormComplete(value);
        setTitleMessage(text);
        setDescription(description);
        setStatusForm(statusForm);
        setIsFormRegister(isRegister);
    }

    const handleClickRegister = (value) => {
        setIsFormRegister(value);
        setMsg("");
        if(value) setIsFormLogin(false);
        else setIsFormLogin(true);
    }

    useEffect(() => {
        if(windowWidth < 575)
            setIsMobile(true);
        else setIsMobile(false);
    },[windowWidth]);

    return (
        <>
            <Button
                type={"primary"}
                color={"primary"}
                onClick={showModal}
            >
                Ingresar
            </Button>
            <Modal
                wrapClassName={"modal-login"}
                title={<>
                    <h3>
                        {
                            (isFormLogin) ? "Iniciar sesión" : (isFormRegister && !isFormLogin) ? "Regístrate" : "Recupera tu contraseña"
                        }
                    </h3>
                    <ColorStripe />
                </>}
                open={isModalOpen}
                maskClosable={true}
                closable={false}
                keyboard={true}
                footer={null}
                onCancel={handleCancel}
            >
                {
                    (isFormComplete) ? (
                            <MessageSuccess
                                title={titleMessage}
                                description={description}
                                isSuccess={statusForm}
                                handleButtonClick={handleCancel}
                            />
                        )
                        : (isFormRegister) ?
                            <FormRegister
                                handleCancel={handleCancel}
                                handleFormSubmit={handleFormSubmit}
                                isMobile={isMobile}
                                setMsg={setMsg}
                                isFormModal={true}
                                title={"¡Bienvenide!"}
                                msg={msg}
                                textRegister={
                                <p className={"text-secondary"}>¿Ya estás registrade? <span onClick={() => handleClickRegister(false)}>Inicia sesión</span></p>}
                            />
                        :
                        (
                            <FormLogin
                                isFormLogin={isFormLogin}
                                isFormModal={true}
                                setIsFormLogin={setIsFormLogin}
                                handleCancel={handleCancel}
                                isMobile={isMobile}
                                title={"¡Bienvenide!"}
                                setMsg={setMsg}
                                msg={msg}
                                handleFormSubmit={handleFormSubmit}
                                textRegister={<p className={"text-secondary"}>¿Todavía no tienes una cuenta? <span onClick={() => handleClickRegister(true)}>Regístrate</span></p>}
                            />
                        )
                }
            </Modal>
        </>
    );
}